import React from 'react';
import { IonCard, IonCardContent } from '@ionic/react';

interface SectionContainerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const SectionContainer: React.FC<SectionContainerProps> = ({ 
  children, 
  style = {} 
}) => {
  return (
    <IonCard 
      style={{ 
        margin: '0.5rem 0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        ...style
      }}
    >
      <IonCardContent style={{ padding: '0.75rem' }}>
        {children}
      </IonCardContent>
    </IonCard>
  );
};

export default SectionContainer;
